import { Component, OnDestroy, Inject, OnInit, OnChanges, ChangeDetectorRef, ViewChild, ElementRef, AfterViewChecked, HostListener } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { navItems } from "../../_nav";
import { Router } from "@angular/router";
import { LoginUser } from "../../model/loginuser";
import { AuthenticationService } from "../../views/authentication.service";
import { salesNavItems } from "../../_nav";
import { CompanyService } from "../../services/company.service";
import { ToastrService } from "ngx-toastr";
import { MatDialog } from "@angular/material/dialog";
import { ErrorDailogComponent } from "../../views/theme/shared/error-dailog/error-dailog.component";
import { environment } from "../../../environments/environment";
import { GeneratePdfComponent } from "../../views/shared/generate-pdf/generate-pdf.component";
import { KeycloakService, KeycloakEventType } from "keycloak-angular";
import { ConfirmTimeComponent } from "../../views/shared/confirm-time/confirm-time.component";
import { JobdashboardService } from "../../services/jobdashboard.service";
import { DashboardService } from "../../views/dashboard/dashboard.service";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html",
  styleUrls: ["./default-layout.component.scss"],
  providers: [ToastrService, DashboardService, JobdashboardService],
})
export class DefaultLayoutComponent implements OnDestroy, ChangeDetectorRef,AfterViewChecked  {
  isMobileView: boolean = false;
  isLandscape: boolean = false;
  // public navItems = navItems;
  navItems = [];
  private idleTimeout: any;
  private idleTimeLimit = environment.idealTime * 60 * 1000;
  @ViewChild('charBox') private myScrollContainer: HTMLElement;
  isProd = environment.production
  sideMenuList = [];
  frightMenuList = [
    {
      name: "Dashboard",
      display: "Dashboard",
      url: "/dashboard/dashboard",
      icon: "fa fa-desktop",
      badge: {
        variant: "info",
        text: "",
      },
    },
  ];
  drumTrucksSideMenuList = [
    {
      name: "Dashboard",
      display: "Dashboard",
      url: "/job-dashboard/dashboard",
      icon: "fa fa-desktop",
      badge: {
        variant: "info",
        text: "",
      },
    },
  ];

  public salesNavItems = salesNavItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;
  public loginUser: LoginUser|any;
  public usertype: string;
  private value: any = {};
  data: any;
  userid = {};
  companylinkeddata = [];
  selectedCompany = undefined;
  selectedCompanyName: string;
  companyType;
  constructor(
    private authService: AuthenticationService,
    private _companyservice: CompanyService,
    public router: Router,
    private _toaster: ToastrService,
    private Keycloak : KeycloakService,
    public dialog: MatDialog,
    private _makePdfService: GeneratePdfComponent,
    private jobDash:JobdashboardService,
    private Dash:DashboardService,
    private breakpointObserver: BreakpointObserver,
    @Inject(DOCUMENT) _document?: any
  ) {
    
    this.breakpointObserver.observe([
      Breakpoints.Handset, // Mobile portrait
      Breakpoints.Tablet,  // Tablet portrait
    ]).subscribe(result => {
      this.isMobileView = result.matches;
    });
    this.resetIdleTimer();
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized =
        _document.body.classList.contains("sidebar-minimized");
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
  markForCheck(): void {
    throw new Error("Method not implemented.");
  }
  detach(): void {
    throw new Error("Method not implemented.");
  }
  detectChanges(): void {
    throw new Error("Method not implemented.");
  }
  checkNoChanges(): void {
    throw new Error("Method not implemented.");
  }
  reattach(): void {
    throw new Error("Method not implemented.");
  }

  resetIdleTimer() {
    clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(() => this.showIdleTimeoutWarning(), this.idleTimeLimit);
  }
  @HostListener('window:mousemove') onUserActivity() {
    this.resetIdleTimer();
  }

  @HostListener('window:keypress') onUserKeyPress() {
    this.resetIdleTimer();
  }
  async showIdleTimeoutWarning() {
    let isLoggedIn = await this.Keycloak.isLoggedIn();
    if(isLoggedIn){
    let dialogConfig = Object.assign(
      { width:'500px'},
      {
        data: {},
      },
      { disableClose: true }
    );
    let dialogRef = this.dialog.open(ConfirmTimeComponent,dialogConfig);
    dialogRef.afterClosed().subscribe(async(data) => {
      if (data == false) {
        // Optionally log the user out
        this.Keycloak.logout();
      }
    })
  }
  }
  isAuthorized: boolean;
  userRoles = [];
  loggedInUserFullName = "";
  loggedInUserRole;
  ngOnInit(): void {
    let token = localStorage.getItem("token")
    this.Keycloak.keycloakEvents$.subscribe(event => {
      if (event.type === KeycloakEventType.OnTokenExpired) {
        console.log('Token expired, re-logging in...');
        // this.reLogin();
        // this.Keycloak.updateToken()
        this.Logout();
      }
    });
    let sessionmsgs =  sessionStorage.getItem('searchMessages');
    if(sessionmsgs){
      this.messages = JSON.parse(sessionmsgs);
    }
    if(token == null){
      this.router.navigateByUrl("login");
    }
    // console.log(this.router.url+"-------------- This the current path");
    this.loginUser = this.authService.getloginUser();
    let featuresList:any = localStorage.getItem('featuresList')
    if (!featuresList) {

      this._companyservice.getCompanyConfiguration().subscribe((data) => {
        console.log(data);
        featuresList = data.result.features.filter(feature => feature.isActivated == true);

        this.companyType = localStorage.getItem("companyType");
        localStorage.setItem("featuresList", JSON.stringify(featuresList));
        const filteredArray = featuresList.filter(item =>
          item.companyType.some(type =>
            type.name === this.companyType && type.isAllowed === true
          )
        );
        const sortedArray = filteredArray.sort((a, b) =>
          a.companyType.find(type => type.name === this.companyType).order -
          b.companyType.find(type => type.name === this.companyType).order
        );
        let tempArr = []
        if (this.companyType == 'Dump_Trucks') {
          tempArr.push(...this.drumTrucksSideMenuList)
          tempArr.push(...sortedArray);
        } else {
          tempArr.push(...this.frightMenuList)
          tempArr.push(...sortedArray)
        }
        this.sideMenuList = tempArr;
        this.update()
      })
    }
    else {
      this.companyType = localStorage.getItem("companyType");
      const filteredArray = JSON.parse(featuresList).filter(item =>
        item.companyType.some(type =>
          type.name === this.companyType && type.isAllowed === true
        )
      );
      const sortedArray = filteredArray.sort((a, b) =>
        a.companyType.find(type => type.name === this.companyType).order -
        b.companyType.find(type => type.name === this.companyType).order
      );
      let tempArr = []
        if (this.companyType == 'Dump_Trucks') {
          tempArr.push(...this.drumTrucksSideMenuList)
          tempArr.push(...sortedArray);
        } else {
          tempArr.push(...this.frightMenuList)
          tempArr.push(...sortedArray)
        }
        this.sideMenuList = tempArr;
      this.update()
    }
}
update(){
  if (this.loginUser) {
    var usercmpdetails = this.loginUser["result"][0]["company"];
    usercmpdetails = usercmpdetails.filter((x) => x.active != false);
    // console.log(this.loginUser["result"]);
    // console.log(usercmpdetails);
    this.companylinkeddata = usercmpdetails;
    if (localStorage.getItem("selectedCompany") != null) {
      this.selectedCompany = localStorage.getItem("selectedCompany");
    } else {
      let defaultCompnayDtls = usercmpdetails.filter(
        (x) => x.default === true
      )[0];
      // console.log(defaultCompnayDtls);
      this.selectedCompany = defaultCompnayDtls["company"];
      localStorage.setItem("selectedCompany", defaultCompnayDtls["company"]);
      localStorage.setItem(
        "role",
        JSON.stringify(defaultCompnayDtls["role"])
      );
      localStorage.setItem("selectedCompanyName", defaultCompnayDtls["name"]);
    }
    this.isAuthorized = this.authService.isAuthorized("dashboard");


      this.navItems = this.sideMenuList;


    this.selectedCompanyName=localStorage.getItem("selectedCompanyName");
    this.getLoggedUserData();

    // this.router.navigateByUrl("/dashboard/dashboard");
  }
}

  getRateconApplicable(){
    let email = this.loginUser?.result[0].email
    this._companyservice.getCarrirRatecon(email).subscribe((data) => {
      console.log(data)
        localStorage.setItem('rateConAccess', data.data.isRateconAccess)
    });
  }
  getLoggedUserData() {
    this._companyservice.getUserRoles.subscribe((roles) => {
      this.userRoles = roles;
      this.loggedInUserRole = this.userRoles.filter(
        (x) => x.roleId.toString() === localStorage.getItem("role")
      )[0].roleDescription;
      // console.log(this.loggedInUserRole);
      let loggedinUserFullName =   localStorage.getItem("loggedinUserFullName");
      if (
        loggedinUserFullName== null ||
        loggedinUserFullName == "" ||
        loggedinUserFullName == "undefined"
      ) {
        this.loggedInUserFullName = localStorage.getItem("selectedCompanyName");
      } else {
        this.loggedInUserFullName = localStorage.getItem("loggedinUserFullName");
      }
    });
  }

  getData() {
    this._companyservice.getCompanyData().subscribe((data) => {
      this.data = data;
    });
  }

//   ngDoCheck(){
//   // console.log(this._companyservice.updateCompany)
//   if(this._companyservice.updateCompany == "Munaif"){
//   // this.update();
//   this.selectedCompanyName = localStorage.getItem("selectedCompanyName");
//   }

// }

  ngOnDestroy(): void {
    clearTimeout(this.idleTimeout);
    this.changes.disconnect();
  }

  showLoadstatus() {
    this.router.navigateByUrl("/load/loadstatus");
  }

  companyselected(event) {
    // console.log(event);
    const cmp = this.companylinkeddata.filter((c) => c.company._id === event)[0];
    if(cmp.company.connection){
    localStorage.setItem("selectedCompany", cmp.company._id);
    localStorage.setItem("selectedCompanyName", cmp.company.name);
    localStorage.setItem("companyType", cmp.company.companyType);
    localStorage.setItem("role", cmp.role);
    var cmpid = localStorage.getItem("selectedCompany");
    this.companyType = cmp.company.companyType;
    this.selectedCompanyName = localStorage.getItem("selectedCompanyName");
    this.userid = this.loginUser["_id"];

      this.navItems = this.sideMenuList;

    this._makePdfService.setPdfData(cmp.company?.companyLogo?.fileName);

    this.getLoggedUserData();
    this._toaster.success(cmp.company.name + " selected successfully", "Success", {
      timeOut: 1000,
    });
    if (this.companyType == 'Dump_Trucks') {
      this.jobDash.changeComapany.next(true)
    } else {
      this.Dash.dashChange.next(true)
    }
    const role = Number(localStorage.getItem("role"));
    this._companyservice.getCompanyConfiguration().subscribe((data) => {
      console.log(data);
      let featuresList = data.result.features.filter(feature => feature.isActivated == true);

      this.companyType = localStorage.getItem("companyType");
      localStorage.setItem("featuresList", JSON.stringify(featuresList));
      const filteredArray = featuresList.filter(item =>
        item.companyType.some(type =>
          type.name === this.companyType && type.isAllowed === true
        )
      );
      const sortedArray = filteredArray.sort((a, b) =>
        a.companyType.find(type => type.name === this.companyType).order -
        b.companyType.find(type => type.name === this.companyType).order
      );
      let tempArr = []
      if (this.companyType == 'Dump_Trucks') {
        tempArr.push(...this.drumTrucksSideMenuList)
        tempArr.push(...sortedArray);
      } else {
        tempArr.push(...this.frightMenuList)
        tempArr.push(...sortedArray)
      }
      this.sideMenuList = tempArr;
      if(this.companyType == 'Dump_Trucks'){
        this.router.navigateByUrl("job-dashboard/dashboard");
      }
      else{
        this.router.navigateByUrl("dashboard/dashboard");
      }
      this.update()
    })
    // this._companyservice.getcompanyroleinfo(cmpid,this.userid).subscribe(data => {
    //   this._toaster.success(cmp.name+" selected successfully", "Success", {timeOut: 1000,});
    //   this.authService.setLogin(data);
    //   this.authService.setRole(data);
    // })
    }
    else{
      // alert("Please verfy the company")
      const dialogData = {};
      dialogData["title"] = "Company Regestration Pending";
      dialogData["message"] =
        "<div class='text-left'>Please complete your registration process by clicking the link from info@loadmiles.com.</div><div class='text-left'> If you do not find it in your inbox, kindly check your Spam or Junk folder</div>";

      const dialogRef = this.dialog.open(ErrorDailogComponent, {
        maxWidth: "400px",
        data: dialogData,
      });
    }
  }
  messages=[
    {
      message:"How can I help you?",
      route:"",
      type:'received'
    }
  ]
  RestPassword(){
    this.router.navigateByUrl("/resetpassword");
  }
  userMangement(){
    this.router.navigateByUrl("/theme/users");
  }
  editcompany(){
    this.router.navigateByUrl("/companysettings/edit-company");
  }
  companyConfiguration(){
    this.router.navigateByUrl("companysettings/configuration");
  }
  Logout() {
    this.authService.clearAuthentication();
    sessionStorage.clear();
  }
  chat = false
  message = ""
  toggleChat(){
    this.chat =  !this.chat
    // if(this.chat==true){
    //   this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    // }
  }
  sendMessage(){

  }
  ngAfterViewChecked() {
    // this.scrollToBottom();
  }
  loadingMsg = false
  typeAndSearch() {
    if (this.loadingMsg == false && this.message!="") {
      this.loadingMsg = true
      let msg = this.message
      this.message = ""
      this.myScrollContainer.scrollIntoView = function () { };
      this.messages.push({
        message: msg,
        route: null,
        type: 'sent',
      })
      this._companyservice.typeAndSearch(msg).subscribe((data) => {
        this.messages.push({
          message: data.message,
          route: data.collection,
          type: 'received'
        })
        sessionStorage.setItem('searchMessages', JSON.stringify(this.messages))
        this.myScrollContainer.scrollIntoView = function () {}
        this.loadingMsg = false
      })
    }
  }
  routeRedirect(route){
    if(route){
      // if(route=="loads"){
        //   this.router.navigateByUrl('/load/loadstatus');
        // }
      switch(route){
        case 'loads':
          this.router.navigateByUrl('/load/loadstatus');
          break;
        case 'pickups':
          this.router.navigateByUrl('/load/loadstatus');
          break;
        case 'dropoffs':
          this.router.navigateByUrl('/load/loadstatus');
          break;
        case 'customers':
          this.router.navigateByUrl('/setup/customers-list');
          break;
        case 'invoices':
          this.router.navigateByUrl('/sales/invoice');
          break;
        case 'drivers':
          this.router.navigateByUrl('/setup/driver-list');
          break;
      }
    }
  }
}
